import React from 'react';
import Modal from '../shared/Modal';
import Formsy, { addValidationRule } from 'formsy-react';
import FormsySimpleInput from '../form/FormsySimpleInput';
import FormsyCheckbox from '../form/FormsyCheckbox';
import FormRadio from '../form/Radio';
import ChefLocationList from './ChefLocationList';

// Phone Number Validation
addValidationRule('isPhone', (values, value) => {
  // eslint-disable-next-line
  return /^[+]?([0-9]*[\.\s\-\(\)]|[0-9]+){3,24}$/.test(value);
});

class ChefEditDetailsModal extends React.Component {
  state = {
    chef: {
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      is_occasion: false,
      is_weekly: false,
      serviceDistricts: [],
      vip: 0
    }
  };

  vipOptions = [
    { value: '0', label: 'Not VIP' },
    { value: '1', label: 'VIP 1 (25 occasions)' },
    { value: '2', label: 'VIP 2 (250 services)' },
    { value: '3', label: 'VIP 3 (500 services)' }
  ];

  render() {
    const { handleChange, handleSubmit } = this;
    const { isOpen, closeModal, availableServiceDistricts, isRoleAdmin } = this.props;
    const {
      first_name,
      last_name,
      email,
      phone_number,
      occasion_opt_in,
      vip
    } = this.state.chef;

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <h2 className="h2 modal__heading">Edit Details</h2>

        <Formsy className="form" onValidSubmit={handleSubmit}>
          <div className="form__row">
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">First Name</p>
              <FormsySimpleInput
                type="text"
                name="first_name"
                placeholder=""
                value={first_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">Last Name</p>
              <FormsySimpleInput
                type="text"
                name="last_name"
                placeholder=""
                value={last_name}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form__row">
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">Email</p>
              <FormsySimpleInput
                type="text"
                name="email"
                placeholder=""
                value={email}
                onChange={handleChange}
                required
                validations="isEmail"
              />
            </div>
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">Phone</p>
              <FormsySimpleInput
                type="text"
                name="phone_number"
                placeholder=""
                validations="isPhone"
                value={phone_number}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form__row">
            <div className="form__row-item">
              <p className="simple-input__label">Location</p>
              <ChefLocationList
                serviceDistricts={this.state.serviceDistricts}
                availableServiceDistricts={availableServiceDistricts}
                toggleDistrict={this.toggleDistrict}
                toggleGroup={this.toggleGroup}
              />
            </div>
          </div>

          <div className="form__row">
            <div className="checkbox-group">
              <FormsyCheckbox
                name="occasion_opt_in"
                checked={occasion_opt_in}
                placeholder="Available for Occasion Services"
                className="checkbox--small checkbox--small-blue checkbox--inline"
                onChange={handleChange}
              />
            </div>
          </div>

          {isRoleAdmin &&
             <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <p className="simple-input__label">VIP</p>
                <FormRadio
                  className="radio--blue radio--large radio--full-width"
                  name="vip"
                  placeholder=""
                  options={this.vipOptions}
                  value={vip.toString() || '0'}
                  onChange={this.handleChange}
                />
              </div>
            </div>
          }

          <div className="form__row">
            <div className="form__row-item--half">
              <div
                className="btn btn--hollow-red-bright btn--full-width"
                onClick={closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="form__row-item--half">
              <input
                type="submit"
                className="btn btn--solid-blue btn--full-width"
                value="Save"
              />
            </div>
          </div>
        </Formsy>
      </Modal>
    );
  }

  handleSubmit = () => {
    const { serviceDistricts: service_district_subsections = [] } = this.state;
    const chef = { ...this.state.chef, service_district_subsections };

    // Note: This block was causing an issue where any updates to chef details would result in an error saying a chef with the same email already exists even if the email had not been altered.  Delete code & comment once approved
    // if (!!chef.email) {
    //   chef.email = chef.email;
    //   chef.unconfirmed_email = chef.email;
    // } else if (chef.email !== this.props.chef.email) {

    if (chef.email !== this.props.chef.email) {
      chef.unconfirmed_email = chef.email;
      chef.email = this.props.chef.email;
    }

    this.props.updateChef(chef);
  };

  handleChange = e => {
    const { target } = e;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (name === 'vip'){
      value = parseInt(value, 10);
    }

    const chef = {
      ...this.state.chef,
      [name]: value
    };

    this.setState({ chef });
  };

  toggleGroup = group => {
    const { serviceDistricts = [] } = this.state;

    // all subsection ids in toggled group
    const groupSubsectionIds = group.service_district_subsections.map(
      d => d.id
    );
    // ids of service districts in state
    const selectedIds = serviceDistricts.map(d => d.id);
    // checks whether all subsections in group already selected
    const doesContainAll = groupSubsectionIds.every(id =>
      selectedIds.includes(id)
    );
    let districts = [];

    if (doesContainAll) {
      // remove subsections in toggled group
      districts = [
        ...serviceDistricts.filter(d => !groupSubsectionIds.includes(d.id))
      ];
    } else {
      // remove any subsections previously selected and add all subsections from group
      districts = [
        ...serviceDistricts.filter(d => !groupSubsectionIds.includes(d.id)),
        ...group.service_district_subsections
      ];
    }

    this.setState({ serviceDistricts: districts });
  };

  componentDidMount() {
    // initialize state from props
    this.setState({
      chef: this.props.chef,
      serviceDistricts: this.props.serviceDistricts
    });
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.chef !== prevProps.chef)
      // TODO: remove empty location array once location is added to chef model
      this.setState({
        chef: { ...this.props.chef, location: [] }
      });
  }
}

export default ChefEditDetailsModal;



// WEBPACK FOOTER //
// ./src/components/chef/ChefEditDetailsModal.js